import { EditorState, EditorAction } from "./types"
import { ViewMode } from "../../model/ViewMode"

const initialState: EditorState = {
    allSnippets: false,
    viewMode: ViewMode.NORMAL,
    lastSave: 0,
    selStart: 0,
    selEnd: 0,
    suggestions: [],
    showSuggestions: false,
    activeIdx: 0,
    autoComplete: false,
}

export const editorReducer = (state: EditorState = initialState, action: EditorAction): EditorState => {
    switch (action.type) {
        case 'SET_ALL_SNIPPETS':
            return { ...state, allSnippets: action.payload }
        case 'SET_VIEW_MODE':
            return { ...state, viewMode: action.payload }
        case 'SET_LAST_SAVE':
            return { ...state, lastSave: action.payload }
        case 'SET_SELECTION':
            return { ...state, selStart: action.payload.start, selEnd: action.payload.end }
        case 'SET_SUGGESTIONS':
            return { ...state, suggestions: action.payload.suggestions, showSuggestions: action.payload.show }
        case 'SET_ACTIVE_INDEX':
            return { ...state, activeIdx: action.payload }
        case 'SET_AUTO_COMPLETE':
            return { ...state, autoComplete: action.payload }
        case 'HIDE_SUGGESTIONS':
            return { ...state, showSuggestions: false }
        case 'UPDATE_AUTOCOMPLETE_FROM_WORDS':
            const hasWords = action.payload && action.payload.length > 0
            return { ...state, autoComplete: hasWords || false }
        default:
            return state
    }
}
